var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarePlanKeyContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8334 15.583H11.3334M14.1667 21.2497H11.3334M22.6667 9.91634H11.3334M28.3334 14.1663V9.63301C28.3334 7.25278 28.3334 6.06267 27.8702 5.15355C27.4627 4.35386 26.8126 3.70369 26.0129 3.29623C25.1038 2.83301 23.9136 2.83301 21.5334 2.83301H12.4667C10.0865 2.83301 8.89641 2.83301 7.98729 3.29623C7.1876 3.70369 6.53743 4.35386 6.12997 5.15355C5.66675 6.06267 5.66675 7.25278 5.66675 9.63301V24.3663C5.66675 26.7466 5.66675 27.9367 6.12997 28.8458C6.53743 29.6455 7.1876 30.2957 7.98729 30.7031C8.89641 31.1663 10.0865 31.1663 12.4667 31.1663H17.7084M25.5001 29.7497C25.5001 29.7497 29.7501 27.724 29.7501 24.6854V21.1404L26.651 20.033C25.9064 19.7663 25.0921 19.7663 24.3475 20.033L21.2501 21.1404V24.6854C21.2501 27.724 25.5001 29.7497 25.5001 29.7497Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlanKeyContacts);
export default __webpack_public_path__ + "static/media/carePlanKeyContacts.05454cccf86942e543a2b61f4f15010e.svg";
export { ForwardRef as ReactComponent };